import {createTheme} from '@mui/material';
import {palette} from './palette';
import {typography} from './typography';
import {scroll} from './scroll';
import breakpoints from './breakpoints';

const theme = createTheme({
    spacing: 4,
    shape: {
        borderRadius: 4,
    },
    palette,
    typography,
    breakpoints,
    components: {
        MuiSnackbar: {
            styleOverrides: {
                root: ({theme}) => ({
                    right: `${theme.spacing(10)} !important`,
                    bottom: `${theme.spacing(10)} !important`,
                    left: 'auto !important',
                    '& .MuiBadge-badge': {
                        backgroundColor: theme.palette.white_100,
                        color: theme.palette.dark,
                        border: `1px solid ${theme.palette.dark}`,
                        boxSizing: 'border-box',
                    },
                }),
            },
        },
        MuiButton: {
            styleOverrides: {
                root: ({theme}) => ({
                    ':disabled': {
                        opacity: 0.7,
                    },
                }),
            },
        },

        MuiAlert: {
            styleOverrides: {
                root: ({theme}) => ({
                    overflow: 'hidden',
                    padding: 'unset',
                    borderRadius: theme.spacing(8),
                    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                    backgroundColor: `${theme.palette.white_100} !important`,
                    maxWidth: theme.spacing(78),
                    border: '1px solid transparent',

                    '&.MuiAlert-standard.MuiAlert-colorError': {
                        borderColor: theme.palette.error.main,
                    },

                    '&.MuiAlert-standard.MuiAlert-colorSuccess': {
                        borderColor: theme.palette.accent,
                    },
                }),

                icon: {
                    display: 'none',
                },

                action: {
                    display: 'none',
                },

                message: {
                    padding: 'unset',
                    width: '100%',
                },
            },
        },

        MuiCssBaseline: {
            styleOverrides: `
        [class*="Mui"] {
          font-family: 'Geist' !important;
        }
        html, body {
          backgroundColor: '#F5F5F5',
        }
        ${scroll} 
      `,
        },
        MuiTypography: {
            styleOverrides: {
                root: ({theme}) => ({
                    color: theme.palette.dark,
                }),
            },
        },
        MuiAvatar: {
            defaultProps: {
                variant: 'square',
            },
            styleOverrides: {
                root: ({theme}) => ({
                    backgroundColor: theme.palette.white_100,
                    width: 112,
                    height: 112,
                    transform: 'translateZ(0)',
                    willChange: 'transform',
                    overflow: 'hidden',
                    '& .MuiAvatar-fallback': {
                        color: theme.palette.dark,
                    },
                }),
            },
        },
    },
});

export default theme;